import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * The mood-image dialog is `type:ui` and may not reach `type:data-access`, so it uploads through
 * this port rather than injecting MediaApiResource. Bound at the app composition root.
 */
export interface MoodImageUploader {
  upload(picture: Blob): Observable<{ id: string }>;
}

export const MOOD_IMAGE_UPLOADER = new InjectionToken<MoodImageUploader>('MOOD_IMAGE_UPLOADER', {
  factory: () => {
    throw new Error(
      'MOOD_IMAGE_UPLOADER is not bound. Provide it at the app composition root, e.g. useFactory over MediaApiResource.fetchTokenAndUploadMedia.'
    );
  },
});
